<template>
  <section id="productMousaSec" class="product-mousa-sec">
    <div class="container">
      <h2 class="section-title section-mousa-title">Chuỗi bảo trì hiệu ứng kép đảo ngược thời gian của Mengsha Ⅱ<!--夢莎逆時雙效保養系列Ⅱ--></h2>
      <p>
        <strong>Thêm thành phần axit nucleic</strong>
        ,Duy trì chức năng hiệu ứng kép ban đầu, chúng tôi tiếp tục theo đuổi sự phát triển về chức năng và kết cấu. Nó nhẹ nhàng hơn trên da, giúp việc bảo trì hàng ngày trở nên dễ dàng và thú vị hơn.
        <!--，維持原有雙效機能，更進一步追求機能性和質感的進化。對肌膚更溫柔，讓每天的保養更輕鬆愉悅。-->
      </p>
      <div class="row mt-4">
        <ProductListItem
          v-for="product in mousaProductList"
          :key="product.id"
          :id="product.id"
          :image="product.image"
          :name="product.name"
          :subtitle="product.subtitle"
          :description="product.description"
          :imageLarge="product.imageLarge"
        />
      </div>
    </div>
  </section>
</template>
<script>
import ProductListItem from "@/components/public/ProductListItem";
export default {
  name: "MousaProductSection",
  components: {
    ProductListItem,
  },
  data() {
    return {
      mousaProductList: [
        {
          id: "5",
          name: "Sữa rửa mặt tác động kép đảo ngược thời gian Mengsha Ⅱ",
          subtitle: "Làm sạch và tẩy trang ＋ Massage ấm",
          description: "Tẩy trang với cảm giác ấm áp",
          image: require("@/assets/public/images/products/夢莎逆時雙效潔面乳Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "6",
          name: "Kem rửa mặt tác dụng gấp đôi thời gian đảo ngược Mengsha Ⅱ",
          subtitle: "Làm sạch da mặt + làm sạch và tẩy trang",
          description: "Các bong bóng dày đặc và mịn thực sự làm sạch mọi ngóc ngách của da",
          image: require("@/assets/public/images/products/夢莎逆時雙效洗顏霜Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "7",
          name: "Xà phòng rửa mặt tác động kép đảo ngược thời gian Mengsha Ⅱ",
          subtitle: "Làm sạch + Mặt nạ bong bóng",
          description: "Bong bóng dày và đầy đặn làm sạch da triệt để",
          image: require("@/assets/public/images/products/夢莎逆時雙效洗顏皂Ⅱ.png"),
          imageLarge: false,
        },
        {
          id: "8",
          name: "Kem dưỡng phục hồi tái tạo hiệu ứng kép Mengsha Reverse Time II",
          subtitle: "Dưỡng ẩm + nhập khẩu",
          description: "Đầy đủ dưỡng ẩm",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活露Ⅱ.png"),
          imageLarge: true,
        },
        {
          id: "9",
          name: "Kem làm sạch và phục hồi tác động kép đảo ngược thời gian của Mengsha Ⅱ",
          subtitle: "Dưỡng ẩm + nhập khẩu",
          description: "Giữ ẩm trong thời gian dài",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活霜Ⅱ.png"),
          imageLarge: false,
        },
        {
          id: "10",
          name: "Mặt nạ hồi sinh tác dụng gấp đôi thời gian của Mengsha Ⅱ",
          subtitle: "Massage + đắp mặt nạ",
          description: "Loại bỏ bụi bẩn khỏi lỗ chân lông và làm cho da trong suốt hơn",
          image: require("@/assets/public/images/products/夢莎逆時雙效賦活面膜Ⅱ.png"),
          imageLarge: true,
        },
      ],
    };
  },
};
</script>
